export default {
  title: {
    en: 'WE MISSED YOU!',
  },
}
